import React, { Context } from 'react'
import { OrderUIStore } from '../stores/order/OrderUIStore'

const OrderContext: Context<{ uiStore: OrderUIStore }> = React.createContext<{ uiStore }>(
  { uiStore: null }
)

export default OrderContext
